<script setup lang="ts">
import axios from 'axios';
import { useRouter } from 'vue-router';

const router = useRouter()

async function logout() {
    await axios.post('/logout')
    router.push({ name: 'Login' })
}
</script>

<template>
    <button class="btn-primary btn-small cursor-pointer" @click="logout">
        Esci
    </button>
</template>